import { ReactTableRowId } from '../gridReactTable'
import { GridCellParams } from './gridCellParams'

/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */
export interface GridEditCellValueParams {
  /**
   * The row id.
   */
  rowId: ReactTableRowId
  /**
   * The field.
   */
  field: string
  /**
   * The new value for the cell.
   */
  value: any
  /**
   * The debounce time in milliseconds.
   */
  debounceMs?: number
}

enum GridCellEditStartReasons {
  enterKeyDown = 'enterKeyDown',
  cellDoubleClick = 'cellDoubleClick',
  printableKeyDown = 'printableKeyDown',
  deleteKeyDown = 'deleteKeyDown',
}

/**
 * Params passed to the `cellEditStart` event.
 */
export interface GridCellEditStartParams extends GridCellParams {
  /**
   * The reason for this event to be triggered.
   */
  reason?: GridCellEditStartReasons
  /**
   * If the reason is related to a keyboard event, it contains which key was pressed.
   */
  key?: string
}

enum GridCellEditStopReasons {
  cellFocusOut = 'cellFocusOut',
  escapeKeyDown = 'escapeKeyDown',
  enterKeyDown = 'enterKeyDown',
  tabKeyDown = 'tabKeyDown',
  shiftTabKeyDown = 'shiftTabKeyDown',
}

/**
 * Params passed to the `cellEditStop event.
 */
export interface GridCellEditStopParams extends GridCellParams {
  /**
   * The reason for this event to be triggered.
   */
  reason?: GridCellEditStopReasons
}

// https://github.com/mui/mui-x/pull/3738#discussion_r798504277
export { GridCellEditStartReasons, GridCellEditStopReasons }
